import { z } from 'zod'

/**
 * Report Issue validation schema
 */

// Maximum file size: 10MB
const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB in bytes

// Accepted file types
const ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf']

export const reportIssueSchema = z.object({
  issue_description: z
    .string()
    .min(1, 'Issue description is required')
    .min(10, 'Please provide at least 10 characters describing the issue')
    .max(2000, 'Description must not exceed 2000 characters'),

  attachment: z
    .instanceof(File)
    .optional()
    .nullable()
    .refine(
      (file) => {
        if (!file) return true // Optional field
        return file.size <= MAX_FILE_SIZE
      },
      {
        message: 'File size must not exceed 10MB',
      }
    )
    .refine(
      (file) => {
        if (!file) return true // Optional field
        return ACCEPTED_FILE_TYPES.includes(file.type)
      },
      {
        message: 'Only JPG, PNG, and PDF files are accepted',
      }
    ),
})

export type ReportIssueFormValues = z.infer<typeof reportIssueSchema>

